import { useEffect, useRef } from 'react';
import { Message } from '../lib/types';

interface UseConversationAutoScrollParams {
  selectedPersonaTab: string | null;
  personaMessages: Record<string, Message[]>;
  isSimulating: boolean;
}

export function useConversationAutoScroll({
  selectedPersonaTab,
  personaMessages,
  isSimulating,
}: UseConversationAutoScrollParams) {
  const conversationScrollRefs = useRef<Record<string, HTMLDivElement | null>>(
    {},
  );

  useEffect(() => {
    const personaId = selectedPersonaTab;
    if (!personaId) return;

    const scrollToBottom = () => {
      const container = conversationScrollRefs.current[personaId];
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    };

    const frameId = requestAnimationFrame(scrollToBottom);
    return () => cancelAnimationFrame(frameId);
  }, [
    selectedPersonaTab,
    personaMessages[selectedPersonaTab ?? '']?.length,
    isSimulating,
  ]);

  return { conversationScrollRefs };
}
